import React, { useRef } from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, SubTitle } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  SubTitle,
  Tooltip,
  Legend,
  ChartDataLabels
);

const BarChart = ({ chartData, chartOptions, onSegmentClick }) => {
  const chartRef = useRef(null);

  const handleClick = (event) => {
    const chart = chartRef.current;

    if (!chart) return;

    const elements = chart.getElementsAtEventForMode(
      event.nativeEvent,
      'nearest',
      { intersect: true },
      false
    );

    if (elements.length > 0) {
      const datasetIndex = elements[0].datasetIndex;
      const index = elements[0].index;
      const datasetLabel = chartData.datasets[datasetIndex].label;
      const label = chartData.labels[index];

      if (onSegmentClick) {
        onSegmentClick({ benefitType: datasetLabel, label });
      }
    }
  };

  return (
    <Bar
      ref={chartRef}
      options={chartOptions}
      data={chartData}
      plugins={[ChartDataLabels]}
      onClick={handleClick}
    />
  );
};

export default BarChart;
